<div class="place-bid-from-form">
  <form [formGroup]="form" [ngClass]="{ 'show-errors-on-touched': errorCondition.touch }">
    <div class="form-group" [class.active]="isExistingCustomerSelected">
      <p class="group-selector" formGroupName="bidTarget">
        <app-input-radio [options]="existingCustomerOption" formControlName="RADIO" />
      </p>
      <div class="p-fluid group-content dropdown" formGroupName="existingCustomer">
        <p-select
          appendTo="body"
          [options]="(customers$ | async) ?? []"
          id="CUSTOMER_ID"
          formControlName="CUSTOMER_ID"
          placeholder=" -- Select Customer --"
          [showTransitionOptions]="'100ms'"
          [hideTransitionOptions]="'50ms'"
          [showClear]="true" />
        <app-input-error controlName="CUSTOMER_ID" [errorCondition]="errorCondition" friendlyName="Customer" customErrorMessage="Required" />
      </div>
    </div>

    <div class="form-group" [class.active]="isNewCustomerSelected">
      <p class="group-selector" formGroupName="bidTarget">
        <app-input-radio [options]="newCustomerOption" formControlName="RADIO" />
      </p>
      <div class="group-content p-fluid row">
        <app-add-edit-customer
          [showSubTitle]="false"
          [inputStyles]="addEditCustomerFormInputStyles"
          (formReady)="onEditCustomerFormReady($event)"
          (formValuesChanged)="onEditCustomerFormValuesChanged($event)" />
      </div>
    </div>

    <div class="form-group" [class.active]="isSelfCustomerSelected" formGroupName="bidTarget">
      <app-input-radio [options]="selfCustomerOption" formControlName="RADIO" />
    </div>
  </form>
</div>
